import axios from 'axios'

const state = () => ({
  payments: [],
})

const getters = {
  getPayments: (state) => state.payments,
}

const actions = {
  async getPayments({ rootState, commit }) {
    const response = await axios.get(rootState.api + '/payments', {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })

    commit('setPayments', response.data)
  },
}

const mutations = {
  setPayments(state, payload) {
    state.payments = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
